module.exports = __webpack_public_path__ + "static/44-b342291dcfdbd70c83e2480c7d2815de.png";